import '../scss/styles.scss';

export default function About() {
    return (
        <section className="about">
            <div id="about" className="about-wrapper">
            <div className="about-text">
                    <h3>Learn More</h3>
                    <h2>About Us</h2>
                    <p>
                    <span>Faraway Sound Productions</span> was launched by <span>Jeremy White</span>, a 20-year veteran of the hospitality industry
                    with years of professional experience managing events of all sizes, from 10 person boardroom style meetings to 300+ guest destination weddings. <span>Faraway Sound Productions</span> was founded in order to offer a distinct level of expertise and service.
                    As the need for audio, visual, and technical support has increased for these types of occasions, we continually build an inventory of high-quality professional equipment. Our goal is to ensure that your next event is flawless,
                    that you spend less time worrying about the production quality and more time focusing on your guest’s satisfaction. <span>Faraway Sound Productions</span> is based out of <span>Nantucket Island</span> and is here to help alleviate the logistical pain points of organizing a high-end program.
                    </p>
                </div>
            </div>
        </section>
    )
}